module.exports = __webpack_public_path__ + "media/images/lig/design-tiles/lig-tile-16-d41bb8d9c5bb1bab7c8b741eadb45f07.jpg";